<template>
  <div>
    <div class="box">
      <BInputText
        label-text="老师姓名"
        v-model="searchParam.name"
        placeholder="老师姓名"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-functions">
        </div>
        <div class="search-result-summary">
          <div class="summary">老师：{{ totalCount }}人</div>
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="teacherList"
        :length="totalPages"
        :total-visible="7"
        :page-num="pageNum"
        v-model="pageNum"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div v-if="!item.data.showDetailBtnFlg" style="display:flex;flex-direction:row;justify-content: center;">
              --
          </div>
          <div
            v-else
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div  class="btn-detail"  @click="handleDetail(item)">
              详情
            </div>
            
            <div class="btn-delete" @click="handleDelete(item.data.id)">
              删除
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import { searchList } from "@/api/teacherManagement";
import { deleteed } from "@/api/account";
import BInputText from "../../components2/BInputText";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Table from "../../components2/Table";
import Hub from "../../events/Hub";
import PopupContents from "../../views2/sample/PopupContents";
import Vue from "vue";
export default {
  name: "TeachTeam",
  components: {
    Table,
    BInputText,
    BBtnSecondary,
  },
  data() {
    return {
      loginUserOrgId: sessionStorage.getItem("orgId"),
      loginUserId: sessionStorage.getItem('userId'),
      loading: false,
      deleteDialog: false,
      totalPages: 0,
      pageNum: 1,
      pageCount: 10,
      totalCount: 0,
      searchParam: {},
      snackbarObj: {
        snackbar: false,
        timeout: -1,
        color: "",
        text: "",
      },
      headers: [
        { text: "ID", value: "indexNum", sortable: false, align: "center", width: '4%' },
        { text: "姓名", value: "teacherName", sortable: false, align: "center", width: '12%' },
        { text: "性别", value: "sex", sortable: false, align: "center", width: '6%' },
        { text: "角色", value: "roleName", sortable: false, align: "center", width: '12%' },
        { text: "身份证号", value: "idCardNum", sortable: false, align: "center", width: '15%' },
        { text: "手机号码", value: "telNo", sortable: false, align: "center", width: '10%' },
        { text: "班级", value: "classNum", sortable: false, align: "center", width: '4%' },
        { text: "添加时间", value: "createTime", sortable: false, align: "center", width: '15%' },
        { text: "操作", value: "actions", sortable: false, align: "center" },
      ],
      teacherList: [],
      deleteId: 0,
      data: {},
      navi: [
        {name: "teach-team"},
      ],
    };
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
  },
  mounted() {
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
  created() {
    // 页面初期化
    this.comUtils.saveStorage(this.$store);
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 查询条件赋值
      if (vm.$store.state.teachTeam_name !== undefined) {
        vm.searchParam.name = this.$store.state.teachTeam_name;
      }
      // 页面初期化
      vm.doSearch(true);
    });
  },
  methods: {
    // 点击查询
    doSearch(flag) {
      this.loading = true;
      if (flag) {
        this.totalPages = 0;
        this.pageNum = 1;
        this.pageCount = 10;
        this.totalCount = 0;
      } else {
        // 查询条件赋值
        if (this.$store.state.teachTeam_name !== undefined) {
          this.searchParam.name = this.$store.state.teachTeam_name;
        }
      }
      this.searchList(this.searchParam);
    },
    // 查询page列表
    async searchList(searchParam) {
      var param = {
        page: this.pageNum,
        limit: this.pageCount,
        name: this.comUtils.trim(searchParam.name),
      };
      // 把查询条件存入缓存
      this.$store.commit("SET_TEST_MANAGEMENT_PARAMS", param);
      const data = await searchList(param);
      if (data.data.searchList != null || data.data.searchList === "") {
        this.teacherList = data.data.searchList;
      }
      this.totalCount = data.data.totalCount;
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
      this.loading = false;
    },
    // 点击详情
    handleDetail(item) {
      sessionStorage.setItem("rowUserOrgId",item.data.orgId)
      sessionStorage.setItem("rowUserId",item.data.id)
      this.$router.push({
        name: "teach-team-detail",
        params: {
          userId: item.data.id,
        },
      });
    },
    // 点击删除
    handleDelete(id) {
      this.data.bodyText = "确认是否删除？";
      this.deleteId = id;
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
    },
    set(value) {
      if (value == 1) {
        this.deleteTeacher();
      }
    },
    async deleteTeacher() {
      var param = {
        id: this.deleteId,
      };
      const data = await deleteed(param);
      if (data.code === 0) {
        this.doSearch(false);
        Vue.prototype.$vsnackbar.show(data.msg);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
</style>
